var map = {
	"./1.jpg": 702,
	"./10.jpg": 156,
	"./11.jpg": 881,
	"./12.jpg": 110,
	"./13.jpg": 635,
	"./14.jpg": 984,
	"./15.jpg": 557,
	"./2.jpg": 841,
	"./3.jpg": 468,
	"./4.jpg": 903,
	"./5.jpg": 250,
	"./6.jpg": 237,
	"./7.jpg": 328,
	"./8.jpg": 59,
	"./9.jpg": 6,
	"./AI.jpg": 129,
	"./CHMS.jpg": 534,
	"./NITO.jpg": 315,
	"./SureCare.jpg": 351,
	"./ccms.jpg": 553,
	"./cloud.jpg": 580,
	"./dataIcon.jpg": 196,
	"./home.jpg": 546,
	"./home1.jpg": 317,
	"./story.jpg": 376
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 248;